import ResponseBaseModel from '../../ResponseBaseModel'

export default class CACA1130ResponseModel extends ResponseBaseModel {
  productNameInformal: string
  creditingRateTenYearLst: [
    {
      rateYears: string
      creditingRate: number
    }
  ]

  productDivName: string
  productDiv2: string
}
